import gql from 'graphql-tag';
import Cookies from 'js-cookie';
import { client } from './prismicHelpers';

/*
 * heroSection query
 */
export const heroSection = gql`
query {
  allHomes {
    edges {
      node {
        heading
        newsletter_title
        newsletter_des
        showlearnmorebtn
        show_chat
        btn_text
        toltip_text
        newsletter_btn_text
        btn_link
        background_video {
          ... on _FileLink {
            url
          }
        }
        chat_img
        image {
          __typename
          ... on _ExternalLink{
            url
          }
          ... on _ImageLink{
            name
            url
            size
          }
        }
      }
    }
    
}
}
`;


export const navLogo = gql`
query{
allNavbars {
    edges{
      node{
      
        pirmary_logo
        secondary_logo

      }
    }
  }
 
}
`;


export const aboutSection = gql`
query {
  allAbouts{
    edges{
      node{
       title
        subtitle
        human_hand
        robot_hand
         about_bg
         about_info {
          logo
          title1
          sub_title
        }
         description_para {
        para1
      }
        
      }
    }
  }
}
`;
export const aboutInfo = gql`
query {
  allAbouts{
    edges{
      node{
        about_info{     
        logo
          title1
        sub_title
      }     
      }
    }
  }
}
`;
export const partnerInfo = gql`
query {
  allPartners{
  edges{
    node{
      title
      description
      sub_title
      partner_bg
      partner_info{
        title1
        bg
        icon
        link
      }
    }
    }
  }
}
`;



export const partnerfund = gql`
query {
  allPartners{
  edges{
    node{
      fund_title
      fund_info{
       title1
       bg
       icon
       link
    }
    }
    }
  }
}
`;


export const projectInfo = gql`
query {
  allProjects{
  edges{
    node{
     project_bg
    title
    sub_title
      description
      project_info{
        title1
        description1
       external_link
        img
        slice_number
      
      }
    }
    }
  }
}
`;

export const innovationBg = gql`
query {
allInnoprograms{
  edges{
    node{
      section_bg
  
   
    }
  }
}
}


`;



export const innovationProgram = gql`
query {
allInnoprograms{
  edges{
    node{
      section_bg
      title
      description
      apply_text
      apply_link
      innovation_info{
        title1
        color
        link
        bg_color
        description1
        icon
        hover_icon
        modal_subtitle
        modal_time
        modal_description
      }
description_para {
  para1
}
      
    }
  }
}
}

`;


export const news = gql`
query {
  

  allNewss {
    edges {
      node {
        news_bg
        title
        description
        card_bg
        card_info
        video_banner1
        card_logo
        logo_name
        card_title
        btn_text
        btn_link1
        slider_info {
          description1
          is_featured
          title1
          logo
          video_link
          featured_logo
          external_link
        }
      }
    }
  }

  }



`;


export const contact = gql`
query {
    
  allContacts {
    edges {
      node {
        social_links {
       link
     }
        socilal {
          twitter
          fb
          linkedin
          youtube
          instragram
        }
      }
    
  }
}
  }



`;

export const footer = gql`
{
  allFooters {
    edges {
      node {
        footer_link {
          link
          doc {
            ...on _FileLink{
              url
            }
          }
          link_text
        }
      }
    }
  }
  allNavbar2s {
    edges {
      node {
        nav_link {
          nav_name
          drop_nav1
          drop_nav1_link
          drop_nav2
          drop_nav2_link
          drop_nav3
          drop_nav3_link
          drop_nav4
          drop_nav4_link
          drop_nav5
          drop_nav5_link
          drop_nav6
          drop_nav6_link
          drop_nav7
          drop_nav7_link
          drop_nav8
          drop_nav8_link
        }
      }
    }
  }
}
`;

export const contactInfo = gql`
query{
  allContacts {
    edges {
      node {
       title
        sub_title
        contact_bg
        card_title
        card_email
        card_email2
        card_number
        video
        video_thumbnail
        location
        location_logo
        location_link
      }
    }
  }
}

`;



export const career = gql`
query {
  
  allCareers {
    edges {
      node {
        title
        sub_title
        career_bg
        description
        career_slider{
          location
          btn_text
          designation
          job_type
        }
    }
  }
}
}


`;


export const careerSlider = gql`
query{
  allCareer_sliders {
    edges {
      node {
        description
        designation
        job_type
        job_description
        btn_text
        link
        location
        job_resposibilities{
    resposibility
      
    }
    working_condition {
          condition
        }
    jobRequires{
      requires
    }
        
      }
    }
  }
}
`;


export const investerCommittee = gql`
query{
  allInvestcommits {
    edges {
      node {
      title
      description
        inverster_info{
          designation
          img
          name
         about
         short_design
         link
        }
      }
    }
  }
}
`;


export const cohortsInfo = gql`
query{
  allCohortss{
    edges{
      node{
        title
        description
        cohort_list{
          title1
        }
        cohorts_info{
          card_title
          card_description
          link
          
        }
        vertical_nav{
        text
          img {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
        
        }
        boost_info {
          card_description
          card_title
          link
          logo {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
           hover_logo {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
        ignite_info {
          card_description
          card_title
          link
          logo {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
           hover_logo {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
        turbo_info {
          card_description
          card_title
          link
          logo {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
           hover_logo {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
      }
    }
  }
 
}
`;

export const teamSlider = gql`
query{
  allTeams{
    edges{
      node{
        
        mamber_info{
          img
          short_design
          about
           type
          social_link
          designation
          name
        }
      }
    }
  }
 
}
`;

export const teamInfo = gql`
query{
  allTeams{
    edges{
      node{
        title
        description
        team_bg
        sub_title
      }
    }
  }
 
}
`;

export const navInfo = gql`
query{
allNavbars {
    edges{
      node{
      
      pirmary_logo
        secondary_logo
        nav_link{
          section_number
          nav_link1
          nav_text
        }
      
      
      }
    }
  }
 
}
`;


export const academicInfo = gql`
query{
  allAcademicinitiativess {
    edges {
      node {
      section_bg
        section_title
        card_info {
         title
         description
         borderColor
         link_text
       }
      
      
       
       
      }
    }
  }
}

`;

export const innoFellow = gql`
query{
  allInno_fellows {
    edges {
      node {
     eligibility_title
        description
        title
        apply_for {
          requires
        }
        apply_text
        apply_email
        apply_for_title
        renewal_title
        criteria_title
        year_end_title
        
        eligibility_title
        year_end_description
        stip_duration_description
        work_profile_description
        work_profile_title
        eligibility_description
        criteria_title
        criteria_description
        stip_duration_title
        renewal_description
      
        
       
      }
    }
  }
}


`;


export const internshipInfo = gql`
query {
allInternships{
  edges{
    node{
      title
    section_bg {
          __typename
          ... on _ExternalLink{
            url
          }
          ... on _ImageLink{
            name
            url
            size
          }
        }
 
   
      description
      description2
      sub_descript
      subtitle
      email
      link1
      link2
      link1_text
      link_text
      email_text
      intern_card{
        title1
        description1
      }
    
   
      }
    }
  }
}

`;



export const innoProgModalInfo = gql`
query {
  allInno_programmes {
    edges {
      node {
        title
        section_bg {
          __typename
          ... on _ExternalLink {
            url
          }
          ... on _ImageLink {
            name
            url
            size
          }
        }
        description
        description_list {
          info
        }
        description_footer
        sub_title
        sub_descript
        apply_text
        email_text
        email
        card {
          title2
          title3
          title1
          description1
          description2
          description2_title
          description3
          description3_title
          description4
          description5
          description6
        }
        apply_link
        date_text
        date_info {
          info
          link
        }
        announcement {
          info
          link
          pdf_link {
            __typename
            ... on _ExternalLink {
              url
            }
            ... on _FileLink {
              name
              url
              size
            }
          }
        }
      }
    }
  }
}

`;

export const roboticChallange = gql`
query {
  allRobotic_challanges {
    edges {
      node {
        title
        section_bg {
          __typename
          ... on _ExternalLink {
            url
          }
          ... on _ImageLink {
            name
            url
            size
          }
        }
        nav_tab {
        id
        hide
        title1
      }
    description
    reg_text
    reg_link
    qualified3_text
    qualified_text
        
    }
  }
}
}

`;



export const callPartipat = gql`
{
  allParticipations {
    edges {
      node {
        title
        description
        title
        sub_description1
        sub_title1
        email
        stage {
          title1
          description1
        }
        email_text
        email_text_description
       
      card {
        title1
        title2
        title3
        
        description1
         description2
         description3
         description4
         description5
         description6
         line_through_date1
         line_through_date2
      }
      }
    }
  }
}


`;

export const qualifiedTeam = gql`
{
  allQualified_teams {
    edges {
      node {
        title
        section_bg {
          __typename
          ... on _ExternalLink {
            url
          }
          ... on _ImageLink {
            name
            url
            size
          }
        }
        title
        card {
          title1
        
          description
          video_link

        }
      }
    }
  }
}



`;





export const qualifiedTeam3 = gql`
{
  allQualified_tm3s {
    edges {
      node {
        title1
        section_bg {
          __typename
          ... on _ExternalLink{
            url
          }
          ... on _ImageLink{
            name
            url
            size
          }
        }
        info {
          title1
          status
          video_link
          description
        } 
      }
    }
  }
}
`;


export const guideLines = gql`
{
  allGis {
    edges {
      node {
         tilte
         sub_title
         sub_des
        description_list {
          para
        }
        scoring {
          desc
        }
        footer_title
        footer_des
      }
    }
  }
}

`;

export const problemDescript = gql`
query {
  allProblem_descripts {
    edges {
      node {
        title
        img {
          __typename
          ... on _ExternalLink {
            url
          }
          ... on _ImageLink {
            name
            url
            size
          }
        }
        description
        img_side_text
        title
        task {
          title1
          description1
        }
        scoring_title
   
        scoring_des
        scoring {
          info
        }
        
    }
  }
}
}
`;

export const proposal = gql`
query {
  allProposal_sus {
    edges {
      node {
        title
        description
        sub_des
        sub_tilte
        propos_info {
          descript
          title1
        }
        additional_title
        addition_info {
          info
        }
        evel_des
        eval_title
        eligib_title
        eligible_des
      }
    }
  }
}

`;

export const lablet = gql`
{
  allLablet_programs {
    edges {
      node {
        title
        
        description
       
        course_title
        
        course_list {
          info
        }
        criteria_des
        content_des
        criteria_text
        work_title
        
        work_description
        content_title
        content_des
        course_list {
          info
        }
        content_list{
          content_info
        }
        applicationDes
        application_title
        recent_offer_title
        offer_list {
          offer_info
          link
        }
        section_bg {
          __typename
          ... on _ExternalLink {
            url
          }
          ... on _ImageLink {
            name
            url
            size
          }
          
        }
      }
    }
  }
}


`;

export const ourChart = gql`
{
  allOur_charters {
    edges {
      node {
        title
        description
        charter_info {
          info_title
          descreption1
          description2
          img {
          ... on _ImageLink {
            url
          }
        }
        }
        section_bg {
          __typename
          ... on _ExternalLink {
            url
          }
          ... on _ImageLink {
            name
            url
            size
          }
          
        }
      }
    }
  }
}


`;



export const health = gql`
{
  allHealths {
    edges {
      node {
        title
        des1
        des2
        des3
        subtitle
        section_bg {
          __typename
          ... on _ImageLink {
            name
            url
            size
          }
        }
        card_img1 {
          __typename
          ... on _ImageLink {
            name
            url
            size
          }
        }
        card_img2 {
          __typename
          ... on _ImageLink {
            name
            url
            size
          }
        }
        card_des1
        card_des2
        health_slider {
          img {
            __typename
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
        card2Des1
        card2Des2
        card2_email
        footer_text
      }
    }
  }
}


`;


export const healthTopCrd = gql`
{
  allHealths {
    edges {
      node {
        
        card_img1 {
          __typename
          ... on _ImageLink {
            name
            url
            size
          }
        }
        card_img2 {
          __typename
          ... on _ImageLink {
            name
            url
            size
          }
        }
       
      }
    }
  }
}


`;

export const healthImg = gql`
{
  allHealths {
    edges {
      node {
        
      
       
        health_slider {
          img {
            __typename
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
     
      }
    }
  }
}


`;



export const ventureFund = gql`
{
  allVenture_funds {
    edges {
      node {
        des1
        des2
      }
    }
  }
}


`;


export const governance_body = gql`
{
  allGovernance_bodys {
    edges {
      node {
        title
        title2
        board_of_director {
          name
          designation
          about_me
          img {
            __typename
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
        info {
          name
          designation
          about_me
          img {
            __typename
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
      }
    }
  }
}

`;


export const lastUpdate = gql`
{
  allLatest_updates {
    edges {
      node {
        btn_text_1
        btn_text_2
      }
    }
  }
}

`;
export const photoGallery = gql`
{
  allPhoto_gallerys {
    edges {
      node {
        title
      
        gallery_photo{
          new_img
          img {
            __typename
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
      }
    }
  }
}


`;



export const navInfo2 = gql`
{
  allNavbar2s {
    edges {
      node {
      
        nav_link {
          nav_name
          drop_nav1
          drop_nav1_link
          drop_nav2
          drop_nav2_link
          drop_nav3
          drop_nav3_link
          drop_nav4
          drop_nav4_link
          drop_nav5
          drop_nav5_link
          drop_nav6
          drop_nav6_link
          drop_nav7
          drop_nav7_link
          drop_nav8
          drop_nav8_link
        }
   
      }
    }
  }
  allSearch_bys {
    edges {
      node {
       search {
         path
         keyword
     
       }
      }
    }
  }
}
`;


export const resourcesInfo = gql`
{
  allResourcess {
    edges {
      node {
        title
        subtitle
        logo_text
        logo_img {
          _linkType
          ... on _ImageLink {
            url
          }
        }
        svg_text
        svg_img {
          _linkType
          ... on _ImageLink {
            url
          }
        }
        png_text
        png_img {
          _linkType
          ... on _ImageLink {
            url
          }
        }
        brand_text
        brand_desc
        req_btn_text
        section_bg {
          _linkType
          ... on _ImageLink {
            url
          }
        }
        req_link
      }
    }
  }
}


`;
export const certification = gql`
{
  allCertifications {
    edges {
      node {
        title
        desc
        footer_text
        email
        section_bg
        recognizers {
          title1
          desc
        }
      }
    }
  }
}



`;
export const rfp = gql`
{
  allReps {
    edges {
      node {
        name_title
        name_f_line
        name_s_line
        date_text
        email_text
        section_bg
        pdf {
          _linkType
          ... on _FileLink {
            url
          }
        }
      }
    }
  }
}

`;


export const mobileNavInfo = gql`
{
  allNavbar2s {
    edges {
      node {
        nav_link {
          nav_name
          drop_nav1
          drop_nav1_link
          drop_nav2
          drop_nav2_link
          drop_nav3
          drop_nav3_link
          drop_nav4
          drop_nav4_link
          drop_nav5
          drop_nav5_link
          drop_nav6
          drop_nav6_link
          drop_nav7
          drop_nav7_link
          drop_nav8
          drop_nav8_link
        }
      }
    }
  }
  allNavbars {
    edges {
      node {
        pirmary_logo
        secondary_logo
      }
    }
  }
}




`;


export const newsInfo = gql`
{
  allEvents {
    edges {
      node {
        section_bg {
          _linkType
          ... on _ImageLink {
            name
            url
            size
          }
        }
        video {
          _linkType
          ... on _ImageLink {
            name
            url
            size
          }
        }
        card_img {
          _linkType
          ... on _ImageLink {
            url
         
          }
        }
        video_text
        video_desc
        vidoe_thumnbnail {
          _linkType
          ... on _ImageLink {
            name
            url
            size
          }
        }
        read_more
        featured_text
        featured {
          img {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
          title
          desc
        }
        all_post {
          img {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
          title
          desc
          date
        }
      }
    }
  }
}
`;

export const publication = gql`
{
  allPublications {
    edges {
      node {
        section_bg {
          _linkType
          ... on _ImageLink {
            name
            url
            size
          }
        }
        title
        subtitle
        public_img {
          _linkType
          ... on _ImageLink {
            name
            url
            size
          }
        }
        public_title
        public_desc
        all_post_text
      }
    }
  }
  allEvents {
    edges {
      node {
        all_post {
          img {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
          title
          desc
          date
        }
      }
    }
  }
}
`;


export const techmoonshots = gql`
{
  allTech_moonshotss {
    edges {
      node {
        title
        subtitle
        section_bg {
          _linkType
          ... on _ImageLink {
            name
            url
            size
          }
        }
        des1
        des2
        video_title
       
        features_title
        features {
          img {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
          text
        }
        service_title
        video_link
        services {
          text
          img {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
        footer_text
        footer_email
      }
    }
  }
}

`;



export const collaborator = gql`
{
  allCollaboratorss {
    edges {
      node {
        title
        email_text
        section_bg {
          _linkType
          ... on _ImageLink {
            name
            url
            size
          }
        }
        subtitle
        brand {
          img {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
        ways_title
        ways{
          index
          text
        }
        tires_title
        tires_des
        tiers {
          img {
            _linkType
            ... on _ImageLink {
              name
              url
              size
            }
          }
          title1
          features2
          features1
          features3
          features4
          features5
        }
      }
    }
  }
}


`;



export const advertisements = gql`
{
  allAdvertisments {
    edges {
      node {
        link
        date
        slider {
      img1
      hide
       link1
    }
        img {
          _linkType
           ... on _ImageLink {
            name
            url
            size
          }
        }
      }
    }
  }
}


`;





export const notifications = gql`
{
  allNotifications {
    edges {
      node {
        notifictions {
          description
          date
          show
        }
      }
    }
  }
}


`;



export const podCast = gql`
{
  allPodcasts {
    edges {
      node {
        title
        subtitle
        section_bg {
          _linkType
          ... on _ImageLink {
            name
            url
            size
          }
        }
        top_banner_header
        top_banner_time
        top_banner_title
        top_banner_des
        top_banner_author
        top_banner_btn_text
        top_banner_btn_link
        play_episode {
          _linkType
          ... on _ImageLink {
            name
            url
            size
          }
        }
        allpodcast {
          header
          time
          author
          title1
          desc
          btn_text
          btn_link
          description
        }
      }
    }
  }
}



`;



export const allEvents = gql`
{
  allEventss {
    edges {
      node {
     
        mode
        date
        time
        title
        reg_btn_text 
        view_btn_text
        view_details_id
        reg_link
        subtitle
        
        section_bg {
          ... on _ImageLink {
            url
          }
        }
        topbanner {
          ... on _ImageLink {
            url
          }
        }
      }
    }
  }
  allNew_events {
    edges {
      node {
        _meta {
          uid
        }
        top_banner {
          ... on _ImageLink {
            url
          }
        }
        event_mode
        event_title
        event_subtitle
        event_date
        event_time
        title
        card_img {
          _linkType
          ... on _ImageLink {
            url
         
          }
        }
        ispastevent
        isactive
        section_bg {
          __typename
          ... on _ImageLink {
            name
            url
            size
          }
        }
      
        reg_link
        reg_btn_text
        summary_title
        summery {
          para
        }
        speakers_title
        footer
      }
    }
  }
}
`;


export const search = gql`
{
  allSearch_bys {
    edges {
      node {
       search {
         path
         keyword
         keyword2
       }
      }
    }
  }

}


`;



export const event = gql`
{
  allNew_events {
    edges {
      node {
        _meta {
          uid
        }
        title
        isactive
        section_bg {
          __typename
          ... on _ImageLink {
            name
            url
            size
          }
        }
       top_banner{
          __typename
          ... on _ImageLink {
            name
            url
            size
          }
        }
        
      reg_link
        reg_btn_text
        summary_title
        summery {
          para
        }
        speakers_title
        speakers {
           img1 {
          __typename
          ... on _ImageLink {
            name
            url
            size
          }
        }
          name
          designation
        }
        agenda_title
        agenda_info {
          timing
          session_type
          session_title
          speaker_name
        }
        footer
      }
    }
  }
}


`;
export const reimaginJourney = gql`
query{
  allReimagin_journeys {
    edges {
      node {
        title
        desc_list {
          text
        }
        des1
        des2
        section_bg {
          __typename
          ... on _ImageLink {
            name
            url
            size
          }
        }
        read_more_title
        link2
        link1_img
        link2_img
        read_more_text
        read_more_img {
          img {
            __typename
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
        profile_info {
          link
          name
          img {
            __typename
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
        contact_text1
        contact_text2
        contact_text3
        contact_text4
        share_text
      }
    }
  }
  allHealths {
    edges {
      node {
        
      
       
        health_slider {
          img {
            __typename
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
     
      }
    }
  }
  
}


`;

export const reimagineHealth2 = gql`
{
  allHealths(uid: "5") {
    edges {
      node {
        title
        des1
        des2
        des3
        subtitle
        section_bg {
          __typename
          ... on _ImageLink {
            name
            url
            size
          }
        }
        card_img1 {
          __typename
          ... on _ImageLink {
            name
            url
            size
          }
        }
        card_img2 {
          __typename
          ... on _ImageLink {
            name
            url
            size
          }
        }
        card_des1
        card_des2
        health_slider {
          img {
            __typename
            ... on _ImageLink {
              name
              url
              size
            }
          }
        }
        card2Des1
        card2Des2
        card2_email
        footer_text
      }
    }
  }
}


`;






































